import * as $ from 'jquery';
import { eID } from '../../services/dom';
import { formatFlightNumber } from '../../services/flight-number';
import InputField from '../../services/input-fields/input-field';
import { $id, $ids } from '../../services/jquery-utils';
import { isDesktop } from './storage';
import { validateFlight } from './validation/flight-validator';

export function loadFlightnumber() {
    const flightFields = [{
        flightnum: new InputField('flightNumber'),
        flightDate: new InputField('flightDate'),
        isReturn: false
    }, {
        flightnum: new InputField('flightNumberReturn'),
        flightDate: new InputField('flightDateReturn'),
        isReturn: true
    }];

    flightFields.forEach(fields => {
        fields.flightnum.$JQuery.focusout(function () {
            // Format flight number
            const $this = $(this);
            const input = ($this.val() as string).trim().split(' ').join('');
            $this.val(formatFlightNumber(input));
        });

        const $bothFields = fields.flightnum.$JQuery
            .add(fields.flightDate.$JQuery);

        $bothFields
            .focusout(() => {
                // Validate flight
                validateFlight(fields.flightnum, fields.flightDate, true);
            })
            .focusin(() => {
                // Make inputs focused
                $bothFields.closest('.inputDiv')
                    .add([eID('message-container'), eID('stopover-container')])
                    .addClass('focused');

                if (!isDesktop) {
                    scrollTo(0, 0);
                }

                if (!isDesktop) $id('back-btn-focused').fadeIn();
            });
    });

    function leaveFocus(): void {
        // Unfocus flight inputs
        let $unfocus = $ids(['message-container', 'stopover-container']);
        flightFields.forEach(field => {
            $unfocus = $unfocus.add(
                field.flightnum.$JQuery
                    .add(field.flightDate.$JQuery)
                    .closest('.inputDiv'));
        });

        $unfocus.removeClass('focused');
        $id('back-btn-focused').fadeOut();
    }

    $id('back-btn-focused').click(leaveFocus);
    $id('mode3').click();
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/modules/widget-core/flightnumber.ts